import { createSlice } from "@reduxjs/toolkit";

export interface RedirectLinksState {
  isLoading: boolean;
  data: any | null;
  error: string | null;
}

const initialState: RedirectLinksState = {
  isLoading: false,
  data: null,
  error: null,
};

export const RedirectLinksSlice = createSlice({
  name: "RedirectLinks",
  initialState,
  reducers: {
    setRedirectLinksLoading: (state) => {
      state.isLoading = true;
      state.error = null;
    },
    setRedirectLinksSuccess: (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
      state.error = null;
    },
  },
});

export const { 
  setRedirectLinksLoading, 
  setRedirectLinksSuccess
} = RedirectLinksSlice.actions;

const RedirectLinksReducer = RedirectLinksSlice.reducer;
export default RedirectLinksReducer;